import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Home, Zap, GitCompare, BookOpen, Calculator } from "lucide-react";
import { prefetchProps } from "@/lib/prefetch";

/* Mobile-only bottom quick-nav. Five highest-intent destinations.
   Visible on screens < lg only. Sits above the StickyCTA via z-index
   ordering and bottom-offset on the CTA. */
const ITEMS = [
  { to: "/",                  Icon: Home,       labelKey: "mbn.home",       fallback: "Home" },
  { to: "/challenges",        Icon: Zap,        labelKey: "mbn.challenges", fallback: "Challenges" },
  { to: "/platforms/compare", Icon: GitCompare, labelKey: "mbn.compare",    fallback: "Compare" },
  { to: "/calculator",        Icon: Calculator, labelKey: "mbn.payout",     fallback: "Payout" },
  { to: "/faq",               Icon: BookOpen,   labelKey: "mbn.faq",        fallback: "FAQ" },
];

export default function MobileBottomNav() {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  return (
    <nav
      aria-label={t("mbn.aria", "Mobile primary navigation")}
      data-testid="mobile-bottom-nav"
      className="lg:hidden fixed bottom-0 inset-x-0 z-30"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div
        className="mx-auto flex items-stretch justify-around border-t"
        style={{
          background: "color-mix(in srgb, var(--surface) 96%, transparent)",
          backdropFilter: "blur(20px)",
          borderTopColor: "color-mix(in srgb, var(--brand) 18%, transparent)",
        }}
      >
        {ITEMS.map(({ to, Icon, labelKey, fallback }) => {
          const active =
            to === "/" ? pathname === "/" : pathname.startsWith(to);
          const label = t(labelKey, fallback);
          return (
            <Link
              key={to}
              to={to}
              data-testid={`bottom-nav-${fallback.toLowerCase()}`}
              {...prefetchProps(to)}
              className="flex-1 flex flex-col items-center justify-center gap-0.5 py-2.5 transition-colors"
              style={{
                color: active ? "var(--brand)" : "var(--text-2)",
              }}
            >
              <Icon size={18} strokeWidth={active ? 2.2 : 1.8} />
              <span
                className="text-[12px] font-medium tracking-wide"
                style={{ opacity: active ? 1 : 0.85 }}
              >
                {label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
